import { ChangeDetectorRef, Component, OnInit, QueryList, ViewChildren } from "@angular/core";
import { locale as italian } from "app/i18n/it";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { CustomerService } from "../../../../modules/customer/customer.service";
import { UtilsService } from "../../../../auth/service/utils.service";
import moment from "moment";
import { UserFigureService } from "../../../../auth/service/user-figure.service";
import { DealsService } from "../../../../auth/service/deals.service";
import { ActivatedRoute, Router } from "@angular/router";
import { DeviceDetectorService } from "ngx-device-detector";
import { IDeal } from "../../../../auth/models/deal-inferface";
import { ToastrService } from "ngx-toastr";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { IContentHeader } from "../../../../layout/components/content-header/content-header.component";
import { ListService } from "../../../../auth/service/list.service";
import { DatepickrComponent } from "../../../../layout/components/datepickr/datepickr.component";
import { IFigure } from "app/auth/models/figures";
import { ICustomer, ICustomerAddressList, ICustomerReferentList } from "../../../../modules/customer/customer.interface";

@Component({
  selector: "app-deals-create",
  templateUrl: "./deals-create.component.html",
  styleUrls: ["./deals-create.component.scss"],
})
export class DealsCreateComponent implements OnInit {
  @ViewChildren(DatepickrComponent) datePicker: QueryList<DatepickrComponent>; //Prendiamo cosi tutti gli input date per eseguire il reset
  public contentHeader: IContentHeader;
  public activeTab: string = "select_type";
  public typeDeal: string = null;
  public isTaskDeal: boolean = false;
  public isTimeMaterialDeal: boolean = false;
  public isDetailSectionCompleted: boolean = false;
  public isThereDiscount: boolean = false; //True if there is a discount in the datatable box_2
  public formGroupDetail: FormGroup;
  public formGroupTask: FormGroup;
  public formGroupTimeMaterial: FormGroup;
  public formGroupBoxes: FormGroup;
  public employees_list: any = [];
  public today: string = moment().format("YYYY-MM-DD");
  public customers_list: ICustomer[] = [];
  public customers_site_list: ICustomerAddressList[] = [];
  public filtered_customers_site_list: ICustomerAddressList[] = [];
  public figures_list: IFigure[] = [];
  public commercial_list: any = [];
  public referents_list: ICustomerReferentList[] = [];
  public filtered_referents_list: ICustomerReferentList[] = [];
  public isMobile: boolean = false;
  public total_deal: number = 0;
  public total_discounted_deal: number = 0;
  public employees_list_datatable: any = []; //Contains the selected employees from the detail section
  public taskTablesRows: any = [];
  public timeMaterialTablesRows: any = [];
  public billingFrequencyList: Array<string> = [];
  public selectedRowIndex: any = null;
  public columnTableTask: any = {
    //Object for back-end tells which columns to show in the generated document
    activity_name: true,
    contract_duration: true,
    months_number: true,
    monthly_canon: true,
    employee_name: false,
    daily_rate: false,
    line_amount: true,
    discount: false,
  };
  public columnTableTimeMaterial: any = {
    //Object for back-end tells which columns to show in the generated document
    figure_id: false,
    period: true,
    total_effort: true,
    daily_rate: true,
    employee_name: false,
    discount: false,
    line_amount: true,
  };
  public showErrors: boolean = false;
  public setMinDateToday: boolean = false;
  public toggleModalAdd: boolean = false;

  constructor(
    public _formBuilder: FormBuilder,
    public _userService: UserService,
    public _customerService: CustomerService,
    public _utilService: UtilsService,
    public _changeDetectorRef: ChangeDetectorRef,
    public _figureService: UserFigureService,
    public _dealService: DealsService,
    private router: Router,
    private _deviceService: DeviceDetectorService,
    public _authService: AuthenticationService,
    private toastService: ToastrService,
    private _listService: ListService,
    private _modalService: NgbModal,
    private _activatedRoute: ActivatedRoute,
  ) {
    this._utilService.disableAutoHideLoading();

    this.contentHeader = {
      headerTitle: italian.data.MENU.CREATE_DEAL,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.DEALS",
            isLink: true,
            link: "/dashboard/deals/list",
          },
          {
            name: italian.data.MENU.CREATE_DEAL,
            isLink: false,
          },
        ],
      },
    };
    this.formGroupDetail = this._formBuilder.group({
      type: new FormControl(null, [Validators.required, Validators.minLength(1), Validators.maxLength(255)]),
      customer: new FormControl(null, [Validators.required]),
      office_site: new FormControl(null, [Validators.required]),
      referent_id: new FormControl(null),
      commercial: new FormControl(null, [Validators.required]),
      name: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
      object: new FormControl(italian.data.OFFER_OBJCET, [Validators.required, Validators.maxLength(255)]),
      employee: new FormControl(null, [Validators.required]),
      start_date: new FormControl(null, [Validators.required]),
      end_date: new FormControl(null, [Validators.required]),
      billing_frequency: new FormControl(null, [Validators.required]),
      tranche_number: new FormControl(null, [Validators.required]),
    });
    this.formGroupTask = this._formBuilder.group({
      activity_name: new FormControl(null),
      contract_duration: new FormControl(null),
      months_number: new FormControl(null),
      monthly_canon: new FormControl(null),
      employee_name: new FormControl(null),
      employee_hash: new FormControl([]),
      daily_rate: new FormControl(null),
      line_amount: new FormControl(null),
      discount: new FormControl(null),
    });
    this.formGroupTimeMaterial = this._formBuilder.group({
      figure_id: new FormControl(null),
      figure_name: new FormControl(null),
      period: new FormControl(null),
      total_effort: new FormControl(null),
      daily_rate: new FormControl(null),
      employee_name: new FormControl(null),
      employee_hash: new FormControl([]),
      line_amount: new FormControl(null),
      discount: new FormControl(null),
    });

    this.formGroupBoxes = this._formBuilder.group({
      box_1: new FormControl(null, [Validators.required]),
      box_2: new FormControl(null, [Validators.required]),
      box_3: new FormControl(null, [Validators.required]),
      box_4: new FormControl(null, [Validators.required]),
      box_5: new FormControl(null, [Validators.required]),
      box_6: new FormControl(null, [Validators.required]),
      box_7: new FormControl(null, [Validators.required]),
      box_8: new FormControl(null, [Validators.required]),
    });
    this.isMobile = this._deviceService.isMobile();
    this._activatedRoute.queryParams.subscribe((params) => {
      this.typeDeal = String(params.type);
      if (!this.typeDeal) {
        this.typeDeal = "Task";
      }

      this.scrollToDetailSection();
    });
  }

  async ngOnInit() {
    if (!this._authService.hasCapability("create_deal")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    if (this._userService.allUserList.length < 1) {
      await this._userService.getAllUsers().then(() => {
        this.employees_list = this._userService.allUserList.filter((user) => user.type_code !== "ex-employee");
      });
    } else {
      this.employees_list = this._userService.allUserList.filter((user) => user.type_code !== "ex-employee");
    }

    this.commercial_list = this.employees_list.filter((user: any) => user.role === "Direzione" || user.role === "Commerciale");
    this.customers_list = await this._customerService.getCustomers();
    this.customers_list = this.customers_list.sort((a, b) => (a.name > b.name ? 1 : -1));
    this.setMinDateToday = this._utilService.themeConfiguration.set_retroactive_date_commission ? false : true;
    this.referents_list = await this._customerService.getReferents();
    this.customers_site_list = await this._customerService.getAddresses();
    this.figures_list = await this._figureService.getList();
    this.billingFrequencyList = await this._listService.getList("billing_frequency");
    this._utilService.hideLoading();
  }

  fieldHasErrors(field_name: string): boolean {
    if (this.showErrors) {
      return this.formGroupDetail.controls[field_name].status === "INVALID";
    } else {
      return this.formGroupDetail.controls[field_name].status === "INVALID" && this.formGroupDetail.controls[field_name].touched;
    }
  }

  async modalOpen(modalBasic, selectedRow: any, index: number) {
    if (selectedRow) {
      if (this.isTaskDeal) {
        this.formGroupTask.patchValue({
          activity_name: selectedRow.activity_name ? selectedRow.activity_name : null,
          contract_duration: selectedRow.contract_duration ? selectedRow.contract_duration : null,
          months_number: selectedRow.months_number ? selectedRow.months_number : null,
          monthly_canon: selectedRow.monthly_canon ? selectedRow.monthly_canon : null,
          employee_name: selectedRow.employee_name ? selectedRow.employee_name : null,
          employee_hash: selectedRow.employee_hash ? selectedRow.employee_hash : null,
          daily_rate: selectedRow.daily_rate ? selectedRow.daily_rate : null,
          line_amount: selectedRow.line_amount ? selectedRow.line_amount : null,
          discount: selectedRow.discount ? selectedRow.discount : null,
        });
      } else {
        this.formGroupTimeMaterial.patchValue({
          figure_id: selectedRow.figure_id ? selectedRow.figure_id : null,
          figure_name: selectedRow.figure_name ? selectedRow.figure_name : null,
          period: selectedRow.period ? selectedRow.period : null,
          total_effort: selectedRow.total_effort ? selectedRow.total_effort : null,
          daily_rate: selectedRow.daily_rate ? selectedRow.daily_rate : null,
          employee_name: selectedRow.employee_name ? selectedRow.employee_name : null,
          employee_hash: selectedRow.employee_hash ? selectedRow.employee_hash : null,
          line_amount: selectedRow.line_amount ? selectedRow.line_amount : null,
          discount: selectedRow.discount ? selectedRow.discount : null,
        });
      }
      this.selectedRowIndex = index;
      this._modalService.open(modalBasic, {
        size: "md",
        centered: true,
        keyboard: false,
        backdrop: false,
      });
    }
  }

  //Here we change site and referents when customer value changes
  changeCustomerInformation(customer: any) {
    //When called we reset referent_id and office_site
    this.formGroupDetail.patchValue({
      referent_id: null,
      office_site: null,
    });

    this.filtered_referents_list = this.referents_list.filter((r) => r.client_id === customer.id);
    this.filtered_customers_site_list = this.customers_site_list.filter((s) => !!s.client && s.client?.id === customer.id);
  }

  //Function for add a new row in the datatable box_2, this one is called automatically when the sectionDetail is completed
  addRow(hash_employee: string = null) {
    if (this.isTaskDeal) {
      //Here we set the values null but someone we will take from the first element if is present
      this.taskTablesRows.push({
        activity_name: null,
        contract_duration: this.formGroupTask.value.contract_duration ? this.formGroupTask.value.contract_duration : null,
        months_number: this.formGroupTask.value.months_number ? this.formGroupTask.value.months_number : null,
        monthly_canon: null,
        employee_name: hash_employee ? this.employees_list.find((emp) => emp.hash === hash_employee).complete_name : null,
        employee_hash: hash_employee ? hash_employee : null,
        daily_rate: null,
        line_amount: null,
        discount: null,
      });
    }
    if (this.isTimeMaterialDeal) {
      //Here we set the values null but someone we will take from the first element if is present
      this.timeMaterialTablesRows.push({
        figure_id: null,
        figure_name: null,
        period: this.formGroupTimeMaterial.value.period ? this.formGroupTimeMaterial.value.period : null,
        total_effort: this.formGroupTimeMaterial.value.total_effort ? this.formGroupTimeMaterial.value.total_effort : null,
        daily_rate: null,
        employee_name: hash_employee ? this.employees_list.find((emp) => emp.hash === hash_employee).complete_name : null,
        employee_hash: hash_employee ? hash_employee : null,
        line_amount: null,
        discount: null,
      });
      this.timeMaterialTablesRows = this.timeMaterialTablesRows.filter((i) => i);
      this._changeDetectorRef.detectChanges();
    }
  }

  //Function for editing a row
  editRow() {
    if (this.isTaskDeal) {
      this.taskTablesRows[this.selectedRowIndex] = this.formGroupTask.value;
      this.taskTablesRows[this.selectedRowIndex].employee_name = this.employees_list.find((emp) => emp.hash === this.formGroupTask.value.employee_hash).complete_name;
    } else {
      //For Time Material we find the name of the figure selected
      this.timeMaterialTablesRows[this.selectedRowIndex] = this.formGroupTimeMaterial.value;
      this.timeMaterialTablesRows[this.selectedRowIndex].employee_name = this.employees_list.find((emp) => emp.hash === this.formGroupTimeMaterial.value.employee_hash).complete_name;
      if (!!this.formGroupTimeMaterial.value.figure_id) {
        this.timeMaterialTablesRows[this.selectedRowIndex].figure_name = this.figures_list.find((figure) => figure.id == this.formGroupTimeMaterial.value.figure_id).name;
      }
    }
    //When save is pressed also we calculate the total Deal Amount
    this.calculateTotalDealAmount();
    this._modalService.dismissAll();
  }

  changeTab(tab: string) {
    this.activeTab = this.activeTab === tab ? "" : tab;
  }

  //This function is called after the user select a type of deal and scroll automatically in the detail section
  scrollToDetailSection() {
    //We check the type of deal, and these two variables will be very useful for changing the scenario
    this.isTaskDeal = this.typeDeal === "Task";
    this.isTimeMaterialDeal = this.typeDeal === "Time Material";
    this.formGroupDetail.patchValue({
      type: this.typeDeal,
    });

    //Scroll and show detail section
    this.activeTab = "deal_detail";
    setTimeout(() => {
      document.getElementById("section2").scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "center",
      });
    });
  }

  //Filter selected employees for the datatable box_2
  fillDataTableEmployeeArray() {
    this.employees_list_datatable = this.employees_list.filter((employee) => this.formGroupDetail.value.employee.includes(employee.hash));
    //if this detail section completed it means the user is comeback in detail section
    if (this.isDetailSectionCompleted) {
      if (this.isTaskDeal) {
        this.taskTablesRows.map((item: any, index: number) => {
          if (item.employee_hash && !this.formGroupDetail.value.employee.includes(item.employee_hash)) {
            //If a user it's been removed we show an alert
            if (this.taskTablesRows.length < 2) {
              this.taskTablesRows.pop();
            } else {
              this.taskTablesRows.splice(index, 1);
              this.taskTablesRows = this.taskTablesRows.filter((i) => i);
            }
            //recalculate total
            this.calculateTotalDealAmount();
            //Alert employee removed
            this.toastService.error(italian.data.ALERT.REMOVED_EMPLOYEE_PRESENT_DATATABLE, italian.data.ALERT.ALERT_TITLE, {
              toastClass: "toast ngx-toastr",
              closeButton: true,
            });
          }
        });
        //Here we check if a new user it's been added, so we have to push it in the datatable automatically
        if (this.formGroupDetail.value.employee && this.formGroupDetail.value.employee.length > 0) {
          this.formGroupDetail.value.employee.map((item) => {
            const alreadyInDatatable = this.taskTablesRows.find((row) => row.employee_hash === item);
            if (!alreadyInDatatable) {
              this.taskTablesRows.push({
                activity_name: null,
                contract_duration: this.formGroupTask.value.contract_duration ? this.formGroupTask.value.contract_duration : null,
                months_number: this.formGroupTask.value.months_number ? this.formGroupTask.value.months_number : null,
                monthly_canon: null,
                employee_name: item ? this.employees_list.find((emp) => emp.hash === item).complete_name : null,
                employee_hash: item ? item : null,
                daily_rate: null,
                line_amount: null,
                discount: null,
              });
            }
          });
        }
      }
      if (this.isTimeMaterialDeal) {
        this.timeMaterialTablesRows.map((item: any, index: number) => {
          //If a user it's been removed we show an alert
          if (item.employee_hash && !this.formGroupDetail.value.employee.includes(item.employee_hash)) {
            //Check if employee datatable is not present in the formGroup we're going to delete and show an error message
            if (this.timeMaterialTablesRows.length < 2) {
              this.timeMaterialTablesRows.pop();
            } else {
              this.timeMaterialTablesRows.splice(index, 1);
              this.timeMaterialTablesRows = this.timeMaterialTablesRows.filter((i) => i);
            }
            //recalculate total
            this.calculateTotalDealAmount();
            //Alert employee removed
            this.toastService.error(italian.data.ALERT.REMOVED_EMPLOYEE_PRESENT_DATATABLE, italian.data.ALERT.ALERT_TITLE, {
              toastClass: "toast ngx-toastr",
              closeButton: true,
            });
          }
        });
        //Here we check if a new user it's been added, so we have to push it in the datatable automatically
        if (this.formGroupDetail.value.employee && this.formGroupDetail.value.employee.length > 0) {
          this.formGroupDetail.value.employee.map((item) => {
            const alreadyInDatatable = this.timeMaterialTablesRows.find((row) => row.employee_hash === item);
            if (!alreadyInDatatable) {
              this.timeMaterialTablesRows.push({
                figure_id: null,
                figure_name: null,
                period: this.formGroupTimeMaterial.value.period ? this.formGroupTimeMaterial.value.period : null,
                total_effort: this.formGroupTimeMaterial.value.total_effort ? this.formGroupTimeMaterial.value.total_effort : null,
                daily_rate: null,
                employee_name: item ? this.employees_list.find((emp) => emp.hash === item).complete_name : null,
                employee_hash: item ? item : null,
                line_amount: null,
                discount: null,
              });
            }
          });
        }
      }
    }
  }

  //This function is called after the user select all the input required for the detail section and scroll automatically in the document section
  async scrollToDocumentSection() {
    this.showErrors = false;
    let invalidFields: Array<string> = [];
    Object.keys(this.formGroupDetail.controls).forEach((key: any) => {
      if (this.formGroupDetail.controls[key].status === "INVALID") {
        invalidFields.push(key);
      }
    });
    if (invalidFields.length === 1) {
      this.showErrors = true;
    }
    //If is not completed we interrupt the scroll
    if (this.isDetailSectionCompleted) {
      return false;
    }
    //Check if we have all values
    if (
      this.formGroupDetail.value.customer &&
      this.formGroupDetail.value.office_site &&
      this.formGroupDetail.value.commercial &&
      this.formGroupDetail.value.object &&
      this.formGroupDetail.value.name &&
      this.formGroupDetail.value.employee &&
      this.formGroupDetail.value.start_date &&
      this.formGroupDetail.value.end_date &&
      this.formGroupDetail.value.billing_frequency &&
      this.formGroupDetail.value.tranche_number
    ) {
      //Check if start date and end date is greater than today date
      const startDate: moment.Moment = moment(this.formGroupDetail.value.start_date);
      const endDate: moment.Moment = moment(this.formGroupDetail.value.end_date);
      if (startDate > endDate) {
        this.formGroupDetail.patchValue({
          start_date: null,
          end_date: null,
        });
        await this._utilService.showSWALError({ text: "ERROR_DATE" });
        this.showErrors = true;
        return false;
      }
      this.formGroupDetail.value.employee.map((empHash) => this.addRow(empHash));
      //Set the variable completed section to true
      this.isDetailSectionCompleted = true;
      //Scroll and show document section
      this.activeTab = "deal_document";
      setTimeout(() => {
        document.getElementById("section3").scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "center",
        });
      });
    }
    this.fillBoxes();
  }

  //Function that fill the boxes depending on the deal's type, the data comes from the backend
  fillBoxes() {
    if (this.isTaskDeal) {
      this.formGroupBoxes.patchValue({
        box_1: this._utilService?.themeConfiguration?.deal_template_boxes?.box_1,
        box_2: this._utilService?.themeConfiguration?.deal_template_boxes?.box_2_task,
        box_3: this._utilService?.themeConfiguration?.deal_template_boxes?.box_3,
        box_4: this._utilService?.themeConfiguration?.deal_template_boxes?.box_4,
        box_5: this._utilService?.themeConfiguration?.deal_template_boxes?.box_5,
        box_6: this._utilService?.themeConfiguration?.deal_template_boxes?.box_6_task,
        box_7: this._utilService?.themeConfiguration?.deal_template_boxes?.box_7,
        box_8: this._utilService?.themeConfiguration?.deal_template_boxes?.box_8,
      });
    }
    if (this.isTimeMaterialDeal) {
      this.formGroupBoxes.patchValue({
        box_1: this._utilService?.themeConfiguration?.deal_template_boxes?.box_1,
        box_2: this._utilService?.themeConfiguration?.deal_template_boxes?.box_2_time_material,
        box_3: this._utilService?.themeConfiguration?.deal_template_boxes?.box_3,
        box_4: this._utilService?.themeConfiguration?.deal_template_boxes?.box_4,
        box_5: this._utilService?.themeConfiguration?.deal_template_boxes?.box_5,
        box_6: this._utilService?.themeConfiguration?.deal_template_boxes?.box_6_time_material,
        box_7: this._utilService?.themeConfiguration?.deal_template_boxes?.box_7,
        box_8: this._utilService?.themeConfiguration?.deal_template_boxes?.box_8,
      });
    }
  }

  formatMoneyValue(value: any, format: string) {
    value = value.trim();
    if (format === "monthly_canon") {
      if (this.isTaskDeal && !!value) {
        this.formGroupTask.patchValue({
          monthly_canon: this._utilService.addDotsToNumber(value),
        });
        this.calculateLineAmountTask(this.formGroupTask.value.monthly_canon);
      } else {
        this.formGroupTask.patchValue({
          monthly_canon: null,
        });
      }
    }
    if (format === "line_amount") {
      if (this.isTaskDeal && !!value) {
        this.formGroupTask.patchValue({
          line_amount: this._utilService.addDotsToNumber(value),
        });
      } else {
        this.formGroupTask.patchValue({
          line_amount: null,
        });
      }
      if (!this.isTaskDeal && !!value) {
        this.formGroupTimeMaterial.patchValue({
          line_amount: this._utilService.addDotsToNumber(value),
        });
      } else {
        this.formGroupTimeMaterial.patchValue({
          line_amount: null,
        });
      }
    }
    if (format === "daily_rate") {
      if (this.isTaskDeal && !!value) {
        this.formGroupTask.patchValue({
          daily_rate: this._utilService.addDotsToNumber(value),
        });
      } else {
        this.formGroupTask.patchValue({
          daily_rate: null,
        });
      }
      if (!this.isTaskDeal && !!value) {
        this.formGroupTimeMaterial.patchValue({
          daily_rate: this._utilService.addDotsToNumber(value),
        });
        this.calculateLineAmountTimeMaterial(this.formGroupTimeMaterial.value.total_effort);
      } else {
        this.formGroupTimeMaterial.patchValue({
          daily_rate: null,
        });
      }
    }
    if (format === "discount") {
      if (this.isTaskDeal && !!value) {
        this.formGroupTask.patchValue({
          discount: this._utilService.addDotsToNumber(value),
        });
      } else {
        this.formGroupTask.patchValue({
          discount: null,
        });
      }
      if (!this.isTaskDeal && !!value) {
        this.formGroupTimeMaterial.patchValue({
          discount: this._utilService.addDotsToNumber(value),
        });
      } else {
        this.formGroupTimeMaterial.patchValue({
          discount: null,
        });
      }
    }
  }

  calculateLineAmountTask(value: any) {
    if (!!value) {
      if (!!this.formGroupTask.value.months_number) {
        const total: number = this._utilService.removeDotsFromNumber(value) * this.formGroupTask.value.months_number;
        this.formGroupTask.patchValue({
          line_amount: this._utilService.addDotsToNumber(total),
        });
        this.taskTablesRows.map((item) => {
          if (!!item.monthly_canon && !!item.months_number) {
            const totalItem: number = this._utilService.removeDotsFromNumber(item.monthly_canon) * item.months_number;
            item.line_amount = this._utilService.addDotsToNumber(totalItem);
          }
        });
      }
    }
    //Recalculate total when line_amount change
    this.calculateTotalDealAmount();
  }

  calculateLineAmountTimeMaterial(value: any) {
    if (!!value) {
      if (this.formGroupTimeMaterial.value.daily_rate) {
        this.formGroupTimeMaterial.patchValue({
          line_amount: this._utilService.addDotsToNumber(this._utilService.removeDotsFromNumber(this.formGroupTimeMaterial.value.daily_rate) * value),
        });
      }
      this.timeMaterialTablesRows.map((item) => {
        if (!!item.daily_rate && !!item.total_effort) {
          const totalItem: number = this._utilService.removeDotsFromNumber(item.daily_rate) * item.total_effort;
          item.line_amount = this._utilService.addDotsToNumber(totalItem);
        }
      });
    }
    //Recalculate total when line_amount change
    this.calculateTotalDealAmount();
  }

  //This function calculates the total effort(the total days of the deal Excluding Sunday, Saturday and the italian holidays)
  calculateEffortTimeMaterial() {
    if (this.formGroupDetail.value.start_date && this.formGroupDetail.value.end_date) {
      let totalEffort: number = 0;
      const availableWorkingDays = this._utilService.themeConfiguration.working_days;
      const startDate: moment.Moment = moment(this.formGroupDetail.value.start_date);
      const endDate: moment.Moment = moment(this.formGroupDetail.value.end_date);
      const numberOfDays: number = endDate.diff(startDate, "days");
      if (typeof numberOfDays == "number" && numberOfDays > 0) {
        for (let i: number = 0; i <= numberOfDays; i++) {
          const date: string = startDate.clone().add(i, "days").format("YYYY-MM-DD");
          //If is not saturday or sunday or an italian holiday we add a day
          //available_working_days contains the working days if you change these in the options, maybe the not working days will be different
          if (availableWorkingDays.includes(Number(moment(date).format("d")))) {
            if (!this._utilService.isHoliday(date)) {
              totalEffort += 1;
            }
          }
        }
        //If is present a row it means there are already selected the employee
        if (this.timeMaterialTablesRows && this.timeMaterialTablesRows.length > 0) {
          this.timeMaterialTablesRows.map((el) => (el.total_effort = totalEffort));
        }
        this.formGroupTimeMaterial.patchValue({
          total_effort: totalEffort,
        });
      }
      this.calculateLineAmountTimeMaterial(this.formGroupTimeMaterial.value.total_effort);
    }
  }

  //This function calculates the month number e the duration for the type task and the period for Time Material type
  async calculateDifferenceInMonth() {
    this.showErrors = false;
    const startDate: moment.Moment = moment(this.formGroupDetail.value.start_date);
    const endDate: moment.Moment = moment(this.formGroupDetail.value.end_date);
    if (this.formGroupDetail.value.start_date && this.formGroupDetail.value.end_date) {
      if (startDate > endDate) {
        this.formGroupDetail.patchValue({
          start_date: null,
          end_date: null,
        });
        this.datePicker.forEach((item: any) => item.clear());
        await this._utilService.showSWALError({ text: "ERROR_DATE" });
        this.showErrors = true;
        return false;
      }
      if (this.isTaskDeal) {
        const months_number = Math.round(endDate.diff(startDate, "months", true));

        if (this.taskTablesRows && this.taskTablesRows.length > 0) {
          this.taskTablesRows.map((el: any) => {
            el.months_number = months_number < 1 ? 1 : months_number
            el.contract_duration = moment(this.formGroupDetail.value.start_date).format("MMMYYYY") + " - " + moment(this.formGroupDetail.value.end_date).format("MMMYYYY");
          });
        }

        this.formGroupTask.patchValue({
          months_number: months_number < 1 ? 1 : months_number,
          contract_duration: moment(this.formGroupDetail.value.start_date).format("MMMYYYY") + " - " + moment(this.formGroupDetail.value.end_date).format("MMMYYYY"),
        });
        this.calculateLineAmountTask(this.formGroupTask.value.monthly_canon);
      }
      if (this.isTimeMaterialDeal) {
        if (this.timeMaterialTablesRows && this.timeMaterialTablesRows.length > 0) {
          this.timeMaterialTablesRows.map((el: any) => (el.period = `${italian.data.FROM} ${startDate.format("DD/MM/YYYY")} ${italian.data.TO} ${endDate.format("DD/MM/YYYY")}`));
        }
        this.formGroupTimeMaterial.patchValue({
          period: `${italian.data.FROM} ${startDate.format("DD/MM/YYYY")} ${italian.data.TO} ${endDate.format("DD/MM/YYYY")}`,
        });
        this.calculateEffortTimeMaterial();
      }
      //Calculate default tranche_number is the difference between start_date and end_date
      this.formGroupDetail.patchValue({
        tranche_number: endDate.diff(startDate, "months") < 1 ? 1 : Math.round(endDate.diff(startDate, "months", true)),
      });
      if (!!this.formGroupDetail.value.billing_frequency) {
        const billing: any = this.billingFrequencyList.find((i: any) => i.id === this.formGroupDetail.value.billing_frequency);
        let tranche: any = this.formGroupDetail.value.tranche_number;
        if (!!tranche) {
          this.formGroupDetail.patchValue({
            tranche_number: Math.round(tranche / billing.other.month_value),
          });
        }
      }
    }
  }

  //Here we calculate the total amount e the total discounted
  calculateTotalDealAmount() {
    //When called we reset the values
    this.isThereDiscount = false;
    this.total_deal = 0;
    this.total_discounted_deal = 0;

    if (this.isTaskDeal) {
      this.taskTablesRows.map((item: any) => {
        //Calculate total
        if (item.line_amount) {
          this.total_deal += this._utilService.removeDotsFromNumber(item.line_amount);
        }
        //Calculate total discounted
        if (item.discount) {
          this.isThereDiscount = true; //We use this variable for showing the Discounted Amount in the box 2
          this.total_discounted_deal += this._utilService.removeDotsFromNumber(item.discount);
        } else {
          //If we don't have the discount in this item, we will calculate the discount amount with the total
          if (item.line_amount) {
            this.total_discounted_deal += this._utilService.removeDotsFromNumber(item.line_amount);
          }
        }
      });
    }
    if (this.isTimeMaterialDeal) {
      this.timeMaterialTablesRows.map((item: any) => {
        //Calculate total
        if (item.line_amount) {
          this.total_deal += this._utilService.removeDotsFromNumber(item.line_amount);
        }
        //Calculate line_amount discounted
        if (item.discount) {
          this.isThereDiscount = true; //We use this variable for showing the Discounted Amount in the box 2
          this.total_discounted_deal += this._utilService.removeDotsFromNumber(item.discount);
        } else {
          //If we don't have the discount in this item, we will calculate the discount amount with the total
          if (item.line_amount) {
            this.total_discounted_deal += this._utilService.removeDotsFromNumber(item.line_amount);
          }
        }
      });
    }
    this.total_deal = this._utilService.addDotsToNumber(this.total_deal);
    this.total_discounted_deal = this._utilService.addDotsToNumber(this.total_discounted_deal);
    //Here we set the total only for the first element of the array(The backend will read this object)
    if (this.isTaskDeal) {
      if (this.taskTablesRows && this.taskTablesRows.length > 0) {
        this.taskTablesRows[0].total_deal = this.total_deal;
        this.taskTablesRows[0].total_discounted_deal = this.total_discounted_deal;
      }
    }
    if (this.isTimeMaterialDeal) {
      if (this.timeMaterialTablesRows && this.timeMaterialTablesRows.length > 0) {
        this.timeMaterialTablesRows[0].total_deal = this.total_deal;
        this.timeMaterialTablesRows[0].total_discounted_deal = this.total_discounted_deal;
      }
    }
  }

  resetForm() {
    this.formGroupDetail.reset();
    this.formGroupTask.reset();
    this.formGroupTimeMaterial.reset();
    this.timeMaterialTablesRows = [];
    this.formGroupBoxes.reset();
    this.taskTablesRows = [];
    this.showErrors = false;
    this.typeDeal = null;
    this.isTaskDeal = false;
    this.isTimeMaterialDeal = false;
    this.isDetailSectionCompleted = false;
    this.isThereDiscount = false; //True if there is a discount in the datatable box_2
    this.total_deal = 0;
    this.total_discounted_deal = 0;
    this.selectedRowIndex = null;
  }

  changeReferentList() {
    this.filtered_referents_list = this.referents_list.filter((item): any => {
      return item.client_id === this.formGroupDetail.value.customer;
    });
  }

  async onReferentModalFormEvent(ref: any) {
    if (!this._authService.hasCapability("create_customer_referent")) {
      await this.router.navigateByUrl("dashboard/main");
      return false;
    }
    this.referents_list = await this._customerService.getReferents();
    const newReferent: any = this.referents_list.find((referent: any) => Number(referent.id) === Number(ref.id));
    setTimeout(() => {
      this.formGroupDetail.patchValue({
        customer: newReferent.client_id,
      });
      this.changeReferentList();
      this.formGroupDetail.patchValue({
        referent_id: newReferent.id,
      });
    });
  }

  async create() {
    this.showErrors = false;
    if (!this._authService.hasCapability("create_deal")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    let errorLineAmount: boolean = false;
    //Check date
    const starDate: moment.Moment = moment(this.formGroupDetail.value.start_date);
    const endDate: moment.Moment = moment(this.formGroupDetail.value.end_date);
    if (starDate.format("YYYY-MM-DD HH:mm:00") > endDate.format("YYYY-MM-DD HH:mm:00")) {
      this.activeTab = "deal_detail";
      setTimeout(() => {
        document.getElementById("section2").scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "center",
        });
      });
      await this._utilService.showSWALError({ text: "ERROR_DATE_INSERT" });
      this.showErrors = true;
      return false;
    }
    //Check empty fields
    let keyToShowError: any = [];
    Object.keys(this.formGroupDetail.controls).map((key) => {
      if (this.formGroupDetail.controls[key].status === "INVALID") {
        keyToShowError.push(key);
      }
    });

    Object.keys(this.formGroupBoxes.controls).map((key) => {
      if (this.formGroupBoxes.controls[key].status === "INVALID") {
        keyToShowError.push(key);
      }
    });
    if (this.formGroupDetail.invalid || this.formGroupBoxes.invalid) {
      let textMessage = await this._utilService.translate("SOME_DATA_ARE_NOT_VALID");
      keyToShowError = await Promise.all(
        keyToShowError.map(async (key) => {
          if (key.includes("box_")) {
            key = key.replace("box_", italian.data.PARAGRAPH + " ");
          }
          key = await this._utilService.translate(key.toUpperCase());
          return key.toLowerCase();
        }),
      );
      textMessage += " " + keyToShowError.join(", ");

      return this._utilService.showSWALEmptyField({ text: textMessage });
    }
    if (this.isTaskDeal) {
      //we control if line_amount has a value and discount if 0 we send it to null
      this.taskTablesRows.map(async (row: any) => {
        if (!row.line_amount) {
          errorLineAmount = true;
        }
      });
    }
    if (this.isTimeMaterialDeal) {
      //we control if line_amount has a value and discount if 0 we send it to null
      this.timeMaterialTablesRows.map(async (row: any) => {
        if (!row.line_amount) {
          errorLineAmount = true;
        }
      });
    }

    if (errorLineAmount) {
      await this._utilService.showSWALError({ text: "ERROR_TOTAL_DEAL" });
      return false;
    }
    //End Check empty fields

    this._utilService.showLoading();
    let data: IDeal = {
      deal_type: this.typeDeal,
      client_id: this.formGroupDetail.value.customer,
      site_id: this.formGroupDetail.value.office_site,
      referent_id: this.formGroupDetail.value.referent_id,
      commercial: this.formGroupDetail.value.commercial,
      object: this.formGroupDetail.value.object,
      name: this.formGroupDetail.value.name,
      employees: this.formGroupDetail.value.employee,
      start_date: this.formGroupDetail.value.start_date,
      end_date: this.formGroupDetail.value.end_date,
      billing_frequency: this.formGroupDetail.value.billing_frequency,
      tranche_number: this.formGroupDetail.value.tranche_number,
      deal_document: {
        box_1: this.formGroupBoxes.value.box_1,
        box_2: this.formGroupBoxes.value.box_2,
        box_3: this.formGroupBoxes.value.box_3,
        box_4: this.formGroupBoxes.value.box_4,
        box_5: this.formGroupBoxes.value.box_5,
        box_6: this.formGroupBoxes.value.box_6,
        box_7: this.formGroupBoxes.value.box_7,
        box_8: this.formGroupBoxes.value.box_8,
        table: JSON.stringify(this.isTaskDeal ? this.taskTablesRows.filter((item) => item) : this.timeMaterialTablesRows.filter((item) => item)),
        table_columns: this.isTaskDeal ? this.columnTableTask : this.columnTableTimeMaterial,
      },
    };
    await this._dealService
      .addDeal(data)
      .then(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_CREATE_DEAL" });
        await this.router.navigateByUrl("/dashboard/deals/list");
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_CREATE_DEAL" });
      });
  }

  takeDate(event: any, field: string) {
    if (field === "start_date") {
      this.formGroupDetail.patchValue({
        start_date: event,
      });
    }
    if (field === "end_date") {
      this.formGroupDetail.patchValue({
        end_date: event,
      });
    }
  }
}
